/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { ProcedurePriority } from 'app/shared/model/enumerations/procedure-priority.model';
import { createEntity, getEntity, reset, updateEntity } from './mwl-item.reducer';

export const MWLItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const admissions = useAppSelector(state => state.admission.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const mWLItemEntity = useAppSelector(state => state.mWLItem.entity);
  const loading = useAppSelector(state => state.mWLItem.loading);
  const updating = useAppSelector(state => state.mWLItem.updating);
  const updateSuccess = useAppSelector(state => state.mWLItem.updateSuccess);
  const procedurePriorityValues = Object.keys(ProcedurePriority);

  const handleClose = () => {
    navigate(`/mwl-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAdmissions({}));
    dispatch(getHospitals({}));
    dispatch(getGlucoUsers({}));
    dispatch(getDiagLabs({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.createdTime !== undefined && typeof values.createdTime !== 'number') {
      values.createdTime = Number(values.createdTime);
    }
    if (values.spsStartDate !== undefined && typeof values.spsStartDate !== 'number') {
      values.spsStartDate = Number(values.spsStartDate);
    }
    if (values.spsStartTime !== undefined && typeof values.spsStartTime !== 'number') {
      values.spsStartTime = Number(values.spsStartTime);
    }
    if (values.spsStatus !== undefined && typeof values.spsStatus !== 'number') {
      values.spsStatus = Number(values.spsStatus);
    }
    if (values.updatedTime !== undefined && typeof values.updatedTime !== 'number') {
      values.updatedTime = Number(values.updatedTime);
    }

    const entity = {
      ...mWLItemEntity,
      ...values,
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      admidIssuer: hospitals.find(it => it.id.toString() === values.admidIssuer?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      accnoIssuer: diagLabs.find(it => it.id.toString() === values.accnoIssuer?.toString()),
      perfPhysName: doctors.find(it => it.id.toString() === values.perfPhysName?.toString()),
      refPhysName: doctors.find(it => it.id.toString() === values.refPhysName?.toString()),
      reqPhysName: doctors.find(it => it.id.toString() === values.reqPhysName?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          procedurePriority: 'STAT',
          ...mWLItemEntity,
          admission: mWLItemEntity?.admission?.id,
          admidIssuer: mWLItemEntity?.admidIssuer?.id,
          patient: mWLItemEntity?.patient?.id,
          accnoIssuer: mWLItemEntity?.accnoIssuer?.id,
          perfPhysName: mWLItemEntity?.perfPhysName?.id,
          refPhysName: mWLItemEntity?.refPhysName?.id,
          reqPhysName: mWLItemEntity?.reqPhysName?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.mWLItem.home.createOrEditLabel" data-cy="MWLItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.mWLItem.home.createOrEditLabel">Create or edit a MWLItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="mwl-item-id"
                  label={translate('tinyMedicRestApp.mWLItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.accessionNo')}
                id="mwl-item-accessionNo"
                name="accessionNo"
                data-cy="accessionNo"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.createdTime')}
                id="mwl-item-createdTime"
                name="createdTime"
                data-cy="createdTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.institution')}
                id="mwl-item-institution"
                name="institution"
                data-cy="institution"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.department')}
                id="mwl-item-department"
                name="department"
                data-cy="department"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.localAet')}
                id="mwl-item-localAet"
                name="localAet"
                data-cy="localAet"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.modality')}
                id="mwl-item-modality"
                name="modality"
                data-cy="modality"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.reqProcId')}
                id="mwl-item-reqProcId"
                name="reqProcId"
                data-cy="reqProcId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.spsId')}
                id="mwl-item-spsId"
                name="spsId"
                data-cy="spsId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.spsStartDate')}
                id="mwl-item-spsStartDate"
                name="spsStartDate"
                data-cy="spsStartDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.spsStartTime')}
                id="mwl-item-spsStartTime"
                name="spsStartTime"
                data-cy="spsStartTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.spsStatus')}
                id="mwl-item-spsStatus"
                name="spsStatus"
                data-cy="spsStatus"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.studyIuid')}
                id="mwl-item-studyIuid"
                name="studyIuid"
                data-cy="studyIuid"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.updatedTime')}
                id="mwl-item-updatedTime"
                name="updatedTime"
                data-cy="updatedTime"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.dicomAttrs')}
                id="mwl-item-dicomAttrs"
                name="dicomAttrs"
                data-cy="dicomAttrs"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.instCode')}
                id="mwl-item-instCode"
                name="instCode"
                data-cy="instCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.deptCode')}
                id="mwl-item-deptCode"
                name="deptCode"
                data-cy="deptCode"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.mWLItem.procedurePriority')}
                id="mwl-item-procedurePriority"
                name="procedurePriority"
                data-cy="procedurePriority"
                type="select"
              >
                {procedurePriorityValues.map(procedurePriority => (
                  <option value={procedurePriority} key={procedurePriority}>
                    {translate(`tinyMedicRestApp.ProcedurePriority.${procedurePriority}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="mwl-item-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.mWLItem.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="mwl-item-admidIssuer"
                name="admidIssuer"
                data-cy="admidIssuer"
                label={translate('tinyMedicRestApp.mWLItem.admidIssuer')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="mwl-item-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.mWLItem.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="mwl-item-accnoIssuer"
                name="accnoIssuer"
                data-cy="accnoIssuer"
                label={translate('tinyMedicRestApp.mWLItem.accnoIssuer')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="mwl-item-perfPhysName"
                name="perfPhysName"
                data-cy="perfPhysName"
                label={translate('tinyMedicRestApp.mWLItem.perfPhysName')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="mwl-item-refPhysName"
                name="refPhysName"
                data-cy="refPhysName"
                label={translate('tinyMedicRestApp.mWLItem.refPhysName')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="mwl-item-reqPhysName"
                name="reqPhysName"
                data-cy="reqPhysName"
                label={translate('tinyMedicRestApp.mWLItem.reqPhysName')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/mwl-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MWLItemUpdate;
